import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EVENT: {
    CHECK_EVENT_REGISTERED: (eventId) => ({ eventId }),
    API: {
      CHECK_EVENT_REGISTERED: apiResourceActionCreator('eventRegistered')
    }
  }
})

export const apiAction = (authToken, eventId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/checkRegistered/${eventId}`, authToken, action.event.api.checkEventRegistered)

function* checkEventRegistered({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload.eventId))
}

const configuration = {
  name: 'checkEventRegistered',
  action: action,
  sagas: checkEventRegistered,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      eventRegistered: action.payload.eventRegistered
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/checkEventRegistered.js